/**
 * Common types shared across the options domain
 */

export enum TransactionType {
  GRANT = 'GRANT',
  VEST = 'VEST',
  CASHLESS_EXERCISE = 'CASHLESS_EXC',
  PURCHASE_EXERCISE = 'PURCHASE_EXC',
  EXPIRE = 'EXPIRE'
}